export default "__VITE_ASSET__CAqMUwhb__"